import React, { Component } from 'react';
import {Transition} from 'semantic-ui-react';
import { Webcam } from './webcam';
import './Camera.css';
var axios = require('axios');

class ClCamera extends Component {
    constructor() {
        super();
        this.webcam = null;
        this.state = {
            capturedImage: null,
            captured: false,
            uploading: false,
            serviceUrl: '',
            visible: true
        }
    }
    handleImageUpload(url) {        
        this.props.onImageUpload({url});
        console.log("In index.js", url)
    }
    componentDidMount() {
        // initialize the camera
        this.canvasElement = document.createElement('canvas');
        this.webcam = new Webcam(
            document.getElementById('webcam'),
            this.canvasElement
        );
        this.webcam.setup().catch(() => {
            alert('Error getting access to your camera');
        });
    }

    componentDidUpdate(prevProps) {
        if (!this.props.offline && (prevProps.offline === true)) {
            // if its online,
            this.batchUploads();
        }
    }
    toggleVisibility = () =>
    this.setState((prevState) => ({ visible: !prevState.visible }))

    render() {
        const {visible} = this.state;
        const imageDisplay = this.state.capturedImage ?
            <img src={this.state.capturedImage} alt="captured" className="centerCamera" width="100%"/>
            :
            <span />;

        const buttons = this.state.captured ?
            <div >
                <button className="captureButton centerCamera" onClick={this.uploadImage} > Use This Photo </button>
                <button className="deleteButton centerCamera" onClick={this.discardImage} > Delete Photo </button>
            </div> :
            <button className="captureButton centerCamera" onClick={this.captureImage} > Take Picture </button>

        const uploading = this.state.uploading ?
            <div><p> Uploading Image, please wait ... </p></div>
            :
            <span />

        return (
            <div>
                <div>
                    {uploading}
                </div>
                <br />      

                <Transition visible={visible} animation='scale' duration={0}>
                <video autoPlay playsInline muted id="webcam" width="100%"/>
                </Transition>
                {/* <Divider hidden /> */}
                
                <div className="ImageCanvas">
                    <div className="ImageOuter">
                        {imageDisplay}
                    </div>
                </div>
                {buttons}
            </div>
        )
    }

    captureImage = async () => {
        const capturedData = this.webcam.takeBase64Photo({ type: 'jpeg', quality: 0.8 });
        console.log(capturedData);
        this.setState({
            captured: true,
            capturedImage: capturedData.base64
        });
        this.toggleVisibility();
    }

    discardImage = () => {
        this.setState({
            captured: false,
            capturedImage: null
        })
        this.toggleVisibility();
    }

    uploadImage = () => {
        if (this.props.offline) {
            console.log("you're using in offline mode sha");
            // create a random string with a prefix
            const prefix = 'cloudy_pwa_';
            // create random string
            const rs = Math.random().toString(36).substr(2, 5);
            localStorage.setItem(`${prefix}${rs}`, this.state.capturedImage);
            alert('Image saved locally, it will be uploaded to your cloud media library once internet connection is detected');
            this.discardImage();
            // save image to local storage
        } else {
            this.setState({ 'uploading': true });
            axios.post(
                `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/image/upload`,
                {
                    file: this.state.capturedImage,
                    upload_preset: process.env.REACT_APP_CLOUD_PRESET
                }
            ).then((data, res) => {
                console.log("In uploadImage", data)
                this.checkUploadStatus(data)
            }
            ).catch((error) => {
                console.log(error)
                alert('Sorry, our servers are having problems..');
                this.setState({ 'uploading': false });
            });
        }
    }

    findLocalItems = (query) => {
        var i, results = [];
        for (i in localStorage) {
            if (localStorage.hasOwnProperty(i)) {
                if (i.match(query) || (!query && typeof i === 'string')) {
                    const value = localStorage.getItem(i);
                    results.push({ key: i, val: value });
                }
            }
        }
        return results;
    }

    checkUploadStatus = (data) => {
        this.setState({ 'uploading': false });
        console.log("Inside checkUploadStatus Before if");
        if (data.status === 200) {
            this.setState({ serviceUrl: data.data.url });
            this.handleImageUpload(data.data.url);
            console.log("Inside checkUploadStatus After if");
            alert('Image Uploaded to Cloudinary Media Library');
            this.discardImage();
        } else {
            console.log(data.status,data.error);
            alert('Sorry, we couldn\'t upload your image', data.error);
        }
    }
    batchUploads = () => {
        // this is where all the images saved can be uploaded as batch uploads
        const images = this.findLocalItems(/^cloudy_pwa_/);
        let error = false;
        if (images.length > 0) {
            this.setState({ 'uploading': true });
            for (let i = 0; i < images.length; i++) {
                // upload
                axios.post(
                    `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/image/upload`,
                    {
                        file: images[i].val,
                        upload_preset: process.env.REACT_APP_CLOUD_PRESET
                    }
                ).then((data) => {
                    this.checkUploadStatus(data)
                    }
                ).catch((error) => {
                    error = true;
                })
            }
            this.setState({ 'uploading': false });
            if (!error) {
                alert("All saved images have been uploaded to your Cloud Media Library");
            }
        }
    }
}
export default ClCamera;